import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { connect } from "react-redux";
// import moment from "moment"
import { format } from "date-fns";

import { query_generate } from "./../../utilities/_query_generate";
import { has_selected_filter } from "./../../utilities/_has_selected_filter";
import { relational_filter_list } from "./../../utilities/_filter_list_builder";
import { signOut } from "../../store/actions/authAction";

import TabNavs from "./components/tabNavs";
import KYCRiecevied from "./components/tabs/kycReceived";
import KYCReceivedRejected from "./components/tabs/kycReceived__reject";
import PendingProcessing from "./components/tabs/pendingProcessing";
import PendingProcessingRejectedByBkashCS from "./components/tabs/pendingProcessing__rejectedByBkashCS";
import Processed from "./components/tabs/processed";

import FilterElement from "./../layout/FilterElement";

import processed_img from "./../../img/kyc/tabs/processed_img.png";
import pending_processing_img from "./../../img/kyc/tabs/pending_processing_img.png";
import received_kyc_img from "./../../img/kyc/tabs/received_kyc_img.png";

import processed_active_img from "./../../img/kyc/tabs/processed_active_img.png";
import pending_processing_active_img from "./../../img/kyc/tabs/pending_processing_active_img.png";
import received_kyc_active_img from "./../../img/kyc/tabs/received_kyc_active_img.png";

import Calendar from "../layout/Calendar";

import "./style.scss";
import Footer from "../Footer/Footer";

class KycTracking extends Component {
  constructor(props) {
    super(props);

    this.state = {
      received_kyc_tab_nav: null,
      pending_processing_tab_nav: null,
      processed_tab_nav: null,

      status: {
        agency_user: {
          api: "api/kyc/v1/closed-leads",
          query: [{ value: "fresh", label: "Fresh" }],
          query_reject: [{ value: "rejected", label: "Reject" }],
          body: undefined,
        },

        bkash_user: {
          api: "api/kyc/v1/list",
          query: [{ value: "bkash_qc_received", label: "bKash QC Received" }],
          body: undefined,
        },

        "bkash-super-user": {
          api: "api/kyc/v1/list",
          query: [
            {
              value: "bkash_super_user_received",
              label: "Bkash Super User Received",
            },
          ],
          body: undefined,
        },
        cluster_manager: {
          api: "api/kyc/v1/list",
          query: [
            {
              value: "bkash_qc_received",
              label: "bKash QC Received",
            },
          ],
          body: undefined,
        },
        territory_manager: {
          api: "api/kyc/v1/list",
          query: [
            {
              value: "bkash_qc_received",
              label: "bKash QC Received",
            },
          ],
          body: undefined,
        },
        area_manager: {
          api: "api/kyc/v1/list",
          query: [
            {
              value: "bkash_qc_received",
              label: "bKash QC Received",
            },
          ],
          body: undefined,
        },
        regional_manager: {
          api: "api/kyc/v1/list",
          query: [
            {
              value: "bkash_qc_received",
              label: "bKash QC Received",
            },
          ],
          body: undefined,
        },
      },
    };
  }

  componentDidMount() {
    const localUserType = JSON.parse(localStorage.getItem("currUserType"));
    this.set_data_set();
    if (localUserType === "agency_user") {
      this.set_data_set__reject();
    }
  }

  componentDidUpdate(prevProps) {
    const localUserType = JSON.parse(localStorage.getItem("currUserType"));
    if (
      this.props.endDate !== prevProps.endDate ||
      this.props.startDate !== prevProps.startDate ||
      this.props.filterElement !== prevProps.filterElement
    ) {
      this.set_data_set();
      if (localUserType === "agency_user") {
        this.set_data_set__reject();
        this.set_data_set();
      }
    }
  }

  set_data_set = () => {
    const localUserType = JSON.parse(localStorage.getItem("currUserType"));

    let query = query_generate([
      {
        key: "team",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.team
            : [],
      },
      {
        key: "cluster_manager",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.managers
            : [],
      },
      {
        key: "territory_manager",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.managers
            : [],
      },
      {
        key: "area_manager",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.managers
            : [],
      },
      {
        key: "regional_manager",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.managers
            : [],
      },
      {
        key: "agency",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.agency
            : [],
      },
      {
        key: "tab",
        values:
          this.state.status[`${localUserType}`]["query"] !== undefined
            ? this.state.status[`${localUserType}`]["query"]
            : [],
      },
    ]);

    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${
          this.state.status[`${localUserType}`]["api"]
        }?start_time=${
          //   moment(this.props.startDate).format(
          //   "yyyy-MM-dd"
          // )
          format(new Date(this.props.startDate), "yyyy-MM-dd")
        }&end_time=${
          //   moment(this.props.endDate).format(
          //   "yyyy-MM-dd"
          // )
          format(new Date(this.props.endDate), "yyyy-MM-dd")
        }&page_index=1&page_size=10${query !== "" ? "&" + query : query}`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        return localUserType === "bkash-super-user"
          ? this.setState({
              received_kyc_tab_nav: {
                image: received_kyc_img,
                active_image: received_kyc_active_img,
                name: "Agency Processing",
                count: res.data.received_count,
                index: 1,
              },
              pending_processing_tab_nav: {
                image: pending_processing_img,
                active_image: pending_processing_active_img,
                name: "bKash Processing",
                count: res.data.pending_processing_count,
                index: 2,
              },
              processed_tab_nav: {
                image: processed_img,
                active_image: processed_active_img,
                name: "Processed",
                count: res.data.processed_count,
                index: 3,
              },
            })
          : localUserType === "agency_user"
          ? this.setState({
              // received_kyc_tab_nav: {
              //   image: received_kyc_img,
              //   active_image: received_kyc_active_img,
              //   name: "Submitted",
              //   count: res.data.received_count,
              //   index: 1,
              // },
              received_rejected_kyc_tab_nav: {
                image: received_kyc_img,
                active_image: received_kyc_active_img,
                name: "Rejected By bKash CS",
                count: res.data.rejected_count,
                index: 4,
              },
              pending_processing_tab_nav: {
                image: pending_processing_img,
                active_image: pending_processing_active_img,
                name: "Pending Processing",
                count: res.data.received_count,
                index: 2,
              },
              processed_tab_nav: {
                image: processed_img,
                active_image: processed_active_img,
                name: "Processed",
                count: res.data.processed_count,
                index: 3,
              },
            })
          : localUserType === "bkash_user"
          ? this.setState({
              // received_kyc_tab_nav: {
              //   image: received_kyc_img,
              //   active_image: received_kyc_active_img,
              //   name: "Submitted",
              //   count: res.data.received_count,
              //   index: 1,
              // },
              // pending_processing_tab_nav: {
              //   image: pending_processing_img,
              //   active_image: pending_processing_active_img,
              //   name: "Pending Processing",
              //   count: res.data.pending_processing_count,
              //   index: 2,
              // },
              processed_tab_nav: {
                image: processed_img,
                active_image: processed_active_img,
                name: "Processed",
                count: res.data.processed_count,
                index: 4,
              },
              // received_rejected_cs_kyc_tab_nav: {
              //   image: received_kyc_img,
              //   active_image: received_kyc_active_img,
              //   name: "Rejected By bKash CS",
              //   count: res.data.bkash_cs_rejected_count,
              //   index: 4,
              // },
            })
          : localUserType === "cluster_manager"
          ? this.setState({
              // received_kyc_tab_nav: {
              //   image: received_kyc_img,
              //   active_image: received_kyc_active_img,
              //   name: "Submitted",
              //   count: res.data.received_count,
              //   index: 1,
              // },
              // pending_processing_tab_nav: {
              //   image: pending_processing_img,
              //   active_image: pending_processing_active_img,
              //   name: "Pending Processing",
              //   count: res.data.pending_processing_count,
              //   index: 2,
              // },
              processed_tab_nav: {
                image: processed_img,
                active_image: processed_active_img,
                name: "Processed",
                count: res.data.processed_count,
                index: 4,
              },
              // received_rejected_cs_kyc_tab_nav: {
              //   image: received_kyc_img,
              //   active_image: received_kyc_active_img,
              //   name: "Rejected By bKash CS",
              //   count: res.data.bkash_cs_rejected_count,
              //   index: 4,
              // },
            })
          : localUserType === "territory_manager"
          ? this.setState({
              processed_tab_nav: {
                image: processed_img,
                active_image: processed_active_img,
                name: "Processed",
                count: res.data.processed_count,
                index: 4,
              },
            })
          : localUserType === "area_manager"
          ? this.setState({
              processed_tab_nav: {
                image: processed_img,
                active_image: processed_active_img,
                name: "Processed",
                count: res.data.processed_count,
                index: 4,
              },
            })
          : localUserType === "regional_manager"
          ? this.setState({
              processed_tab_nav: {
                image: processed_img,
                active_image: processed_active_img,
                name: "Processed",
                count: res.data.processed_count,
                index: 4,
              },
            })
          : null;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  set_data_set__reject = () => {
    const localUserType = JSON.parse(localStorage.getItem("currUserType"));

    let query = query_generate([
      {
        key: "team",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.team
            : [],
      },
      {
        key: "cluster_manager",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.managers
            : [],
      },
      {
        key: "territory_manager",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.managers
            : [],
      },
      {
        key: "area_manager",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.managers
            : [],
      },
      {
        key: "regional_manager",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.managers
            : [],
      },
      {
        key: "agency",
        values:
          this.props.filterElement.relational !== undefined
            ? this.props.filterElement.relational.agency
            : [],
      },
      {
        key: "tab",
        values:
          this.state.status[`${localUserType}`]["query_reject"] !== undefined
            ? this.state.status[`${localUserType}`]["query_reject"]
            : [],
      },
    ]);

    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${
          this.state.status[`${localUserType}`]["api"]
        }?start_time=${
          //   moment(this.props.startDate).format(
          //   "yyyy-MM-dd"
          // )
          format(new Date(this.props.startDate), "yyyy-MM-dd")
        }&end_time=${
          // moment(this.props.endDate).format(
          //   "yyyy-MM-dd"
          // )
          format(new Date(this.props.endDate), "yyyy-MM-dd")
        }&page_index=1&page_size=10${query !== "" ? "&" + query : query}`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        return localUserType === "agency_user"
          ? this.setState({
              received_rejected_kyc_tab_nav: {
                image: received_kyc_img,
                active_image: received_kyc_active_img,
                name: "Rejected By bKash",
                count: res.data.rejected_count,
                index: 4,
              },
            })
          : null;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  create_filter_elements = (filter, type) =>
    filter.map((item, index) => (
      <FilterElement
        key={index}
        {...item}
        selectedValue={this.props.filterElement}
        type={type}
      />
    ));

  async remove_all_filter() {
    await this.props.updateFilterElement({
      kyc_received: {
        relational: {},
        non_relational: {},
      },
    });
  }

  render() {
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    if (!localUserToken) return <Redirect to="/signin" />;

    let current_time = Date.now().valueOf() / 1000;
    if (this.props.expiration < current_time) this.props.signOut();
    return (
      <div className="main-container">
        <div
          className={
            JSON.parse(localStorage.getItem("currUserType")) !== "agency_user"
              ? "kyc"
              : "full-width-kyc"
          }
        >
          <div className="page-settings">
            <Calendar
              page={"kyc_tracker"}
              startDate={this.props.startDate}
              endDate={this.props.endDate}
            />
            {JSON.parse(localStorage.getItem("currUserType")) !==
              "agency_user" &&
              this.props.filterHide && (
                <div
                  className="filter-container"
                  ref={(node) => {
                    this.node = node;
                  }}
                >
                  <div className="header">
                    <div className="heading">Select Filter</div>
                    {has_selected_filter(this.props.filterElement) ? (
                      <div className="clear">
                        <button
                          className="active-button"
                          onClick={() => this.remove_all_filter()}
                        >
                          Clear All
                        </button>
                      </div>
                    ) : (
                      <div className="clear">
                        <button
                          className="inactive-button"
                          onClick={() => this.remove_all_filter()}
                          disabled
                        >
                          Clear All
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="body">
                    {this.create_filter_elements(
                      relational_filter_list("kyc"),
                      "relational"
                    )}
                  </div>
                </div>
              )}
          </div>

          <TabNavs
            tab_navs={
              JSON.parse(localStorage.getItem("currUserType")) === "agency_user"
                ? [
                    this.state.received_rejected_kyc_tab_nav,
                    // this.state.received_kyc_tab_nav,
                    this.state.pending_processing_tab_nav,
                    this.state.processed_tab_nav,
                  ]
                : JSON.parse(localStorage.getItem("currUserType")) ===
                  "bkash_user"
                ? [
                    // REMOVAL OF BKASH QC APR13-21
                    // this.state.received_kyc_tab_nav,
                    // this.state.pending_processing_tab_nav,
                    // this.state.received_rejected_cs_kyc_tab_nav,
                    this.state.processed_tab_nav,
                  ]
                : JSON.parse(localStorage.getItem("currUserType")) ===
                  "cluster_manager"
                ? [
                    // REMOVAL OF TABS MAY25-21
                    // this.state.received_rejected_cs_kyc_tab_nav,
                    // this.state.received_kyc_tab_nav,
                    // this.state.pending_processing_tab_nav,
                    this.state.processed_tab_nav,
                  ]
                : JSON.parse(localStorage.getItem("currUserType")) ===
                  "territory_manager"
                ? [
                    // REMOVAL OF TABS MAY25-21
                    // this.state.received_rejected_cs_kyc_tab_nav,
                    // this.state.received_kyc_tab_nav,
                    // this.state.pending_processing_tab_nav,
                    this.state.processed_tab_nav,
                  ]
                : JSON.parse(localStorage.getItem("currUserType")) ===
                  "area_manager"
                ? [
                    // REMOVAL OF TABS MAY25-21
                    // this.state.received_rejected_cs_kyc_tab_nav,
                    // this.state.received_kyc_tab_nav,
                    // this.state.pending_processing_tab_nav,
                    this.state.processed_tab_nav,
                  ]
                : JSON.parse(localStorage.getItem("currUserType")) ===
                  "regional_manager"
                ? [
                    // REMOVAL OF TABS MAY25-21
                    // this.state.received_rejected_cs_kyc_tab_nav,
                    // this.state.received_kyc_tab_nav,
                    // this.state.pending_processing_tab_nav,
                    this.state.processed_tab_nav,
                  ]
                : [
                    this.state.received_kyc_tab_nav,
                    this.state.pending_processing_tab_nav,
                    this.state.processed_tab_nav,
                  ]
            }
          />
        </div>

        {parseInt(this.props.selectedTab) === 1 ? (
          <KYCRiecevied
            tabs_set_data_set={this.set_data_set}
            heading={
              this.state.received_kyc_tab_nav
                ? this.state.received_kyc_tab_nav.name
                : "..."
            }
          />
        ) : parseInt(this.props.selectedTab) === 4 ? (
          JSON.parse(localStorage.getItem("currUserType")) === "agency_user" ? (
            <KYCReceivedRejected
              tabs_set_data_set={this.set_data_set}
              heading={
                this.state.received_rejected_kyc_tab_nav
                  ? this.state.received_rejected_kyc_tab_nav.name
                  : "..."
              }
            />
          ) : JSON.parse(localStorage.getItem("currUserType")) ===
            "bkash_user" ? (
            <Processed
              tabs_set_data_set={this.set_data_set}
              heading={
                this.state.processed_tab_nav
                  ? this.state.processed_tab_nav.name
                  : "..."
              }
            />
          ) : JSON.parse(localStorage.getItem("currUserType")) ===
              "cluster_manager" ||
            "territory_manager" ||
            "area_manager" ||
            "regional_manager" ? (
            // <PendingProcessingRejectedByBkashCS
            //   tabs_set_data_set={this.set_data_set}
            //   heading={
            //     this.state.received_rejected_cs_kyc_tab_nav
            //       ? this.state.received_rejected_cs_kyc_tab_nav.name
            //       : "..."
            //   }
            // />
            // CHANGED TO PROCESSED ON MAY25-21
            <Processed
              tabs_set_data_set={this.set_data_set}
              heading={
                this.state.processed_tab_nav
                  ? this.state.processed_tab_nav.name
                  : "..."
              }
            />
          ) : null
        ) : parseInt(this.props.selectedTab) === 2 ? (
          <PendingProcessing
            tabs_set_data_set={this.set_data_set}
            heading={
              this.state.pending_processing_tab_nav
                ? this.state.pending_processing_tab_nav.name
                : "..."
            }
          />
        ) : parseInt(this.props.selectedTab) === 3 ? (
          <Processed
            tabs_set_data_set={this.set_data_set}
            heading={
              this.state.processed_tab_nav
                ? this.state.processed_tab_nav.name
                : "..."
            }
          />
        ) : null}

        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let startDate = state.calendar.kyc_tracker
    ? state.calendar.kyc_tracker.startDate
    : state.calendar.kyc_default.startDate;

  let endDate = state.calendar.kyc_tracker
    ? state.calendar.kyc_tracker.endDate
    : state.calendar.kyc_default.endDate;

  let filterElement = state.filterElement.kyc
    ? state.filterElement.kyc
    : state.filterElement.default;
  let filterHide = state.filter.filterHide;
  let selectedTab = state.selectedTab.selectedTabIndex;

  let expiration = state.auth.authToken
    ? state.auth.authToken.expiration
    : 20000;

  return {
    startDate,
    endDate,
    filterElement,
    filterHide,
    selectedTab,
    expiration,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(signOut()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(KycTracking);
